// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { useLocales } from "react-localized"
import { IonGrid, IonText, IonRow, IonCol } from "@ionic/react"
import { LoginButton } from "./LoginButton"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSignIn } from "@fortawesome/free-solid-svg-icons"


const LoginRequiredContainer: React.FC = () => {
  const error = sessionStorage.getItem("oauth2-error")
  const {gettext} = useLocales()
  if (!!error) {
    sessionStorage.removeItem("oauth2-error")
  }
  return (
    <>
      <IonGrid style={{paddingTop: "var(--section-padding)"}}>
        <IonRow className="panel main">
          <IonCol>
            <IonText>
              <p>{gettext("Je moet aangemeld zijn om deze pagina te bekijken.")}</p>
            </IonText>
            <LoginButton style={{marginTop: "22px"}}>
              <FontAwesomeIcon icon={faSignIn}/>
              {gettext("Aanmelden")}
            </LoginButton>
          </IonCol>
        </IonRow>
      </IonGrid>
    </>
  )
}

export default LoginRequiredContainer